export default __webpack_public_path__ + "static/media/closet1-1024w.fd2e1a2d.png";